export default "__VITE_ASSET__CNWvTBz5__"